import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Countdown from "react-countdown";
import Button from "../../components/common/Button";
import Text from "../../components/common/Text";
import FlexBox from "../../components/common/FlexBox";
import Div from "../../components/common/Div";
import HR from "../../components/common/HR";
import IconBar from "../Partials/IconBar";
import SubmitTestBox from "../Partials/SubmitTestBox";
import Question from "../Tests/Question";
import {
  tenzero,
  urlbase,
  headers,
  NumberToLetter,
  fixOptions,
  getTime,
} from "../../constants/Constants";
import Latex from "react-latex-next";
import R_MultipleChoice from "./R_MultipleChoice";
import ReviewQuestion from "./ReviewQuestion";
import { SubmitTest } from "../../api/test";

//fixed options save
export default function Review(props) {
  const history = useHistory();

  if (
    props === undefined ||
    props.location === undefined ||
    props.location.state === undefined ||
    props.location.state.user === undefined ||
    props.location.state.test === undefined ||
    props.location.state.questions === undefined ||
    props.location.state.submission === undefined ||
    props.location.state.startTime === undefined
  )
    history.push("/login");

  const user = props.location.state.user;
  const test = props.location.state.test;
  const questions = props.location.state.questions;
  const grouptest = props.location.state.grouptest;
  const submission = props.location.state.submission; //submission on this screen is not a nested array anymore, submission[] not submission[][]
  const startTime = props.location.state.startTime;
  const closeDate = props.location.state.close_date;
  var tempQArr;
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  var options = JSON.parse(localStorage.getItem("Options"));

  const numberOfQuestions = questions.length;
  const arr = Array.apply(null, Array(numberOfQuestions)); //.map(function () {}); //mapping the blank method seems redundant, as the array is already populated with undefined's

  const [submitDisplay, setSubmitDisplay] = useState(false);
  const [timeUsed, setTimeUsed] = useState();

  function preventBack() {
    window.history.forward();
  }
  setTimeout(preventBack, 0);

  function timeOut() {
    SubmitTestHandler();
  }

  function setTimer() {
    let date = new Date(startTime);
    date.setMinutes(date.getMinutes() + test.timealloc);
    return date;
  }

  function submitTest() {
    setSubmitDisplay(true);
  }

  function determineSubmission(question, value, index) {
    if (
      (question.type !== "single" &&
        question.type !== "multiple" &&
        question.type !== "true/false" &&
        question.type !== "number") ||
      value === undefined
    )
      return "";

    if (question.type === "single") {
      return value === NumberToLetter(index) ? 1 : 0;
    }
    if (question.type === "true/false") {
      return value === question.options[index].text.toUpperCase() ? 1 : 0;
      //return ((value == (question.options[index].correct === 1 ? "TRUE" : "FALSE")) ? 1 : 0);
    }
    if (question.type === "number") {
      return value[1] === NumberToLetter(index);
    }
    if (question.type === "multiple") {
      return value.includes(NumberToLetter(index));
    }
  }

  function createQuestionSubmissionObject() {
    let questionArr = [];
    var tempQArr = questions;
    for (var i = 0; i < questions.length; i++) {
      let Options = [];
      for (var j = 0; j < options[i].length; j++) {
        const option = {
          answer:
            (questions[i].type === "order" || questions[i].type === "match") &&
            submission[i] !== undefined &&
            submission[i][j] !== undefined
              ? submission[i][j]
              : "", // answer for order or column match
          isCorrect: options[i][j].correct,
          isSelected: determineSubmission(questions[i], submission[i], j), // single or multiple types, or number
          optionID: options[i][j].id,
          correctAnswer: options[i][j].text,
        };
        Options.push(option);
      }
      let question = {
        answer:
          (questions[i].type === "text" || questions[i].type === "number") &&
          submission[i] !== undefined &&
          submission[i][0] !== undefined
            ? submission[i][0]
            : "", // type or number question
        id: questions[i].id,
        test_id: test.id,
        type: questions[i].type,
        options: Options,
      };
      questionArr.push(question);
    }
    return questionArr;
  }

  const SubmitTestHandler = async () => {
    const grouptest_id =
      grouptest !== undefined ? "&grouptest_id=".concat(grouptest.id) : "";

    const finishTime = new Date();

    let diffTime = Math.abs(finishTime.getTime() - startTime.getTime());
    diffTime = diffTime / 1000;
    let diffTimeInMinutes = diffTime / 60;
    let finalTimeDiff = diffTimeInMinutes.toFixed(2);
    const questionSubmission = createQuestionSubmissionObject();

    let body;
    if (grouptest === undefined)
      body = {
        token: user.token,
        test_id: test.id,
        questions: questionSubmission,
        start_time: startTime,
        close_date: closeDate,
        test_version: test.version,
        device_id: "",
      };
    else
      body = {
        token: user.token,
        test_id: test.id,
        questions: questionSubmission,
        start_time: startTime,
        close_date: closeDate,
        grouptest_id: grouptest.id,
        device_id: "",
        test_version: test.version,
      };

    localStorage.setItem("time", getTime(startTime));

    const submitResponse = await SubmitTest(
      user.token,
      test.id,
      body,
      grouptest_id
    );

    if (submitResponse.code === 200) {
      history.push("/results", {
        user: user,
        error: false,
        test: test,
        questions: questions,
        submission: submission,
        data: submitResponse.data,
        grouptest: grouptest,
      });
    } else {
      history.push("/results", {
        user: user,
        data: submitResponse.data,
        error: true,
      });
    }
  };

  const submitDisplayYes = () => {
    SubmitTestHandler();
  };

  function ReviewAllQuestions() {
    //displays all of the questions in the test
    let arr = [];
    for (var i = 0; i < questions.length; i++) {
      //const letter = NumberToLetter(i);
      const curNum = i;
      const value = (
        <div
          style={{
            fontSize: "0.9rem",
            backgroundColor: "rgb(33, 42, 65)",
            padding: "10px",
            paddingBottom: "10px",
            borderRadius: "5px",
            fontWeight: "bold",
            textAlign: "center",
            marginTop: "15px",
          }}
        >
          <ReviewQuestion
            question={questions[i]}
            submission={submission}
            questionNumber={i}
          />
          <Button
            backgroundColor={"#ccc"}
            color={"#00112e"}
            borderRadius={"5px"}
            width={"100%"}
            fontWeight={"bold"}
            height={"fit-content"}
            padding={"10px 15px"}
            fontSize={"1rem"}
            textTransform={"uppercase"}
            onClick={() => {
              history.push("/editquestion", {
                user: user,
                questions: questions,
                submission: submission,
                test: test,
                alreadyStarted: "STARTED",
                startTime: startTime,
                questionNumber: curNum,
                groupTest: grouptest,
              });
            }}
          >
            EDIT
          </Button>
        </div>
      );
      arr.push(value);
    }
    return <Div>{arr}</Div>;
  }

  function SubmitTestButton() {
    return (
      <div style={{ marginTop: "15px", marginBottom: "15px" }}>
        <Button
          fontSize={"1rem"}
          padding={"15px 15px"}
          width={"100%"}
          marginTop={"15px"}
          borderRadius={"5px"}
          backgroundColor={"#fbcd02"}
          color={"#00112e"}
          fontWeight={"bold"}
          textTransform={"uppercase"}
          onClick={() => setSubmitDisplay(true)}
        >
          SUBMIT
        </Button>
      </div>
    );
  }

  return (
    <>
      <SubmitTestBox
        display={submitDisplay}
        handler1={() => setSubmitDisplay(false)}
        handler2={submitDisplayYes}
      />
      <div
        style={{ height: "100%", width: windowWidth >= 800 ? "50%" : "90%" }}
      >
        <div className="HeaderBox">
          <IconBar location={"test"} user={user} />
        </div>

        <div
          style={{
            color: "rgb(251, 205, 2)",
            fontSize: "1.1rem",
            paddingTop: "10px",
            paddingBottom: "10px",
            borderRadius: "5px",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          {test.name}
        </div>
        <Div
          padding={"10px"}
          borderRadius={"5px"}
          backgroundColor={"#fbcd02"}
          height={"100%"}
          marginBottom={"10px"}
          style={{ boxSizing: "border-box" }}
        >
          <Div style={{ display: "flex", alignItems: "center" }}>
            <Div
              style={{
                fontWeight: "bold",
                color: "#00112e",
              }}
            >
              <span
                style={{
                  fontWeight: "bold",
                  color: "#00112e",
                  fontSize: "0.9rem",
                }}
              >
                Time Remaining:&nbsp;&nbsp;
              </span>
              <Countdown
                date={setTimer()}
                daysInHours={true}
                onComplete={timeOut}
                renderer={({ hours, minutes, seconds }) => (
                  <span
                    style={{
                      fontWeight: "bold",
                      color: "#00112e",
                      fontSize: "0.9rem",
                    }}
                  >
                    {hours}:{minutes}:{seconds}
                  </span>
                )}
              />
            </Div>
          </Div>
        </Div>
        <div>
          {ReviewAllQuestions()}
          {SubmitTestButton()}
        </div>
      </div>
    </>
  );
}
